import { render, staticRenderFns } from "./subjectanalysis.vue?vue&type=template&id=0f650b1b&"
import script from "./subjectanalysis.vue?vue&type=script&lang=js&"
export * from "./subjectanalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports